var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTailormedLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 20,
    viewBox: "0 0 135 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_6214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1495 1.81008V19.5791H4.9029V1.81008H0V0.676514H11.0518V1.81008H6.1495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3013 13.3724H14.2533L11.7312 19.579H10.371L18.3342 0.109375L26.1837 19.579H24.8234L22.3013 13.3724ZM21.8479 12.2388L18.3059 3.28335L14.7068 12.2388H21.8479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3776 0.676514V19.5791H29.131V0.676514H30.3776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7255 0.676514V18.4455H41.9965V19.5791H35.4789V0.676514H36.7255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6568 10.1701C62.6568 15.6112 58.3782 19.8904 52.8523 19.8904C47.3264 19.8904 43.0478 15.6112 43.0478 10.1701C43.0478 7.56961 44.0805 5.07513 45.9193 3.23638C47.758 1.39763 50.2519 0.364258 52.8523 0.364258C55.4528 0.364258 57.9466 1.39763 59.7853 3.23638C61.6241 5.07513 62.6568 7.56961 62.6568 10.1701ZM61.3531 10.1701C61.3531 5.32368 57.7257 1.55498 52.8517 1.55498C47.9777 1.55498 44.3503 5.32432 44.3503 10.1701C44.3503 15.0158 47.9777 18.7569 52.8517 18.7569C57.7257 18.7569 61.3531 14.9875 61.3531 10.1701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6694 19.5791L68.5488 10.6519H67.9817V19.5791H66.7351V0.676514H69.455C70.9007 0.676514 72.2038 0.790191 73.4511 1.63988C74.9244 2.66041 75.4061 4.2185 75.4061 5.69245C75.4061 7.56267 74.5846 9.49005 72.2321 10.2832C71.4832 10.5318 70.6984 10.6564 69.9084 10.6519L76.0862 19.5791H74.6694ZM67.9817 9.51831H69.7954C72.4877 9.51831 74.103 8.10151 74.103 5.66419C74.103 3.76571 73.1678 2.77345 72.4305 2.37654C71.6374 1.92311 70.2771 1.80943 69.5404 1.80943H67.9817V9.51766V9.51831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6365 19.5791L81.6686 0.676514H85.296L89.9998 11.9839L94.7042 0.676514H98.331L101.364 19.5791H96.9996L95.4974 8.29997L90.7653 19.5791H89.2349L84.5028 8.29997L83.0006 19.5791H78.6365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.306 4.36043H108.986V8.0161H114.993V11.7H108.986V15.8945H115.306V19.5784H104.622V0.676514H115.306V4.36043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.827 0.676514C127.321 0.676514 129.956 1.04516 132.279 3.28403C133.951 4.89928 135 7.10989 135 10.0572C135 13.0044 133.98 15.1868 132.421 16.7455C129.815 19.3813 126.555 19.5797 124.969 19.5797H118.848V0.676514H124.827ZM123.212 15.8952H124.373C125.28 15.8952 127.264 15.8104 128.681 14.6197C129.701 13.7693 130.523 12.1541 130.523 10.0572C130.523 7.96022 129.701 6.71298 128.964 5.97632C127.547 4.55953 125.705 4.36108 124.373 4.36108H123.212V15.8945V15.8952Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_6214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 19.7812,
    fill: "white",
    transform: "translate(0 0.109375)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailormedLogoIcon);
export default __webpack_public_path__ + "static/media/tailormed-logo-icon.66140f6dfaec43ec26ab5ba3e5420a61.svg";
export { ForwardRef as ReactComponent };